import React from 'react'

import NewAgency from './NewAgency'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewAgencyPage = () => (
  <section>
    <header>
      <PageTitle>New Agency</PageTitle>
    </header>
    <NewAgency showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewAgencyPage



// WEBPACK FOOTER //
// ./src/components/Agencies/NewAgencyPage.jsx